import {GetCurrentData} from '../../../../Utils/_helpers/GetCurrentData'
import {defaultRegion} from '../../../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {GetFilterContactTag, getFilterContactTag} from './TagSlice/TagsSlices'
import {stopLoading} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'

import {useGetContactsMutation} from '../../../../../services/cellcast.v3'
import {ContactRequest, ListContactResponse, Tag} from '../../../../../services/cellcast.v3.types'
import {useLazyGetGroupQuery} from '../../../../../services/cellcast'
import {useEffect, useState} from 'react'

type params = {
  page: number
  size: number
  search: string
}

export function useContactByTag() {
  const dispatch = useDispatch()
  const currentUser = GetCurrentData()
  const [fetchContactRegion, {data: contactsRegion}] = useGetContactsMutation()

  const tagsContact = useSelector(getFilterContactTag)
  const dbOptions: any[] = useSelector(
    (state: any) => state?.subscriberData?.FieldName?.data?.fields
  )

  const [fetchGroup, {data: group}] = useLazyGetGroupQuery()
  const [fields, setFields] = useState<string[]>([])
  useEffect(() => {
    if (group && group.data && group.data.fields) {
      setFields(group.data.fields)
    }
  }, [group])

  const getDataContact = (page: params, groupId: string, tagId: string) => {
    fetchGroup(groupId, true)
    if (currentUser?.region === defaultRegion) {
      const params = {
        id: groupId,
        page: {page: page.page, size: page.size, tagId: tagId},
      } as any
      if (page?.search && page.search !== '') {
        params.page.search = page.search
      }
      dispatch(GetFilterContactTag(params))
    } else {
      const regionParam: ContactRequest = {
        page: page.page ?? 1,
        limit: page.size ?? 10,
        group_id: groupId,
        tag_ids: tagId.split(','),
        search: page.search,
      }
      fetchContactRegion({
        action: 'find_contact',
        data: regionParam,
      })
      dispatch(stopLoading())
    }
  }

  const mapRegionData = (data: ListContactResponse | undefined) => {
    if (!data) {
      return {items: []}
    }

    let responseData = {...data}
    const mapData = data?.items?.map((item: any) => {
      const fields = []

      const objectKeys = Object.keys(item.fields)
      const existingFields: any = item.fields
      if (existingFields !== undefined && objectKeys.length > 0) {
        for (let i = 0; i < objectKeys.length; i++) {
          const key = objectKeys[i]
          fields.push({
            name: key,
            value: existingFields[key],
          })
        }
      }

      return {
        ...item,
        fields: fields,
      }
    })

    responseData.items = mapData
    return responseData
  }

  return {
    getDataContact,
    tagsContact:
      currentUser?.region === defaultRegion ? tagsContact : mapRegionData(contactsRegion?.data),
    dbOptions: currentUser?.region === defaultRegion ? dbOptions : fields,
  }
}
